export default __webpack_public_path__ + "static/media/maximize.be17a90e.svg";